import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { loginWithToken } = useApp();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin/login", { email, password });
      loginWithToken(data.token, data.user);
      toast.success("Signed in as admin");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login" className="mx-auto max-w-md px-4 py-20">
      <div className="border border-white/10 bg-zinc-950 p-8">
        <div className="flex items-center gap-2 mb-1"><ShieldCheck className="h-5 w-5 text-blue-400"/><p className="mono-label text-blue-400">Admin</p></div>
        <h1 className="font-display text-2xl mb-6">Sign in to admin</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs text-white/60">Email</Label>
            <Input data-testid="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-black border-white/10 mt-1" required/>
          </div>
          <div>
            <Label className="text-xs text-white/60">Password</Label>
            <Input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-black border-white/10 mt-1" required/>
          </div>
          <Button data-testid="admin-login-submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-500 rounded-none">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin"/>} Sign in
          </Button>
        </form>
      </div>
    </div>
  );
}
